jQuery( document ).ready(function($) {
    $("#miniCartClose").click(function() {
  		$(".wrapper-top-cart #dropdown-cart").slideUp();
	});
  
  	/* Cookie Bottom Bar Set */
  	var refreshIdCount = 0;
  	var refreshId = setInterval(function() {
		if ($("#cookie-consent-dialogBox").size() > 0 ){
			$("#cookie-consent-dialogBox .cc-btn-decision.cc-allow").click(function() {
				$("#shopify-section-footer .footer-bottom").animate({
					'padding-bottom' : 30
				}, "slow");    
			});
          	if ($("#cookie-consent-dialogBox.cc-invisible").size() > 0 ){
              	$("#shopify-section-footer .footer-bottom").animate({
					'padding-bottom' : 30
				}, "slow");
            }
			clearInterval(refreshId);
		}
      	refreshIdCount++;
      	if(refreshIdCount == 10){
        	clearInterval(refreshId);
      	}
	}, 500);
  
  	/* TACTICAL BUNDLE Charcoal product selected */
  	var refreshIdCount2 = 0;
  	var refreshId2 = setInterval(function() {
      	if ($("#tactical-bundle tr.mw-gp__table__row:first-child select.mw-gp__table__variants option[value=32444250456173]").size() > 0 ){
          
          	var sortBySelect = document.querySelector("#tactical-bundle tr.mw-gp__table__row:first-child select.mw-gp__table__variants"); 
			sortBySelect.value = "32444250456173"; 
			sortBySelect.dispatchEvent(new Event("change"));
          
          	clearInterval(refreshId2);
        }
      	refreshIdCount2++;
      	if(refreshIdCount2 == 15){
        	clearInterval(refreshId2);
      	}
	}, 500);
  
  	/* TURKEY BUNDLE CHITOSAM 100 varient selected */
	var refreshIdCount3 = 0;
	var refreshId3 = setInterval(function() {
		if ($("#turkey-bundle tr.mw-gp__table__row:first-child select.mw-gp__table__variants option[value=17732296736857]").size() > 0 ){
          
          	var sortBySelect = document.querySelector("#turkey-bundle tr.mw-gp__table__row:first-child select.mw-gp__table__variants"); 
			sortBySelect.value = "17732296736857"; 
			sortBySelect.dispatchEvent(new Event("change"));
          
          	clearInterval(refreshId3);
        }
      	refreshIdCount3++;
      	if(refreshIdCount3 == 15){
        	clearInterval(refreshId3);
      	}
	}, 500);
  	
  
  	/* Search Bar Drawer open js */
  	$(document).on('click','.site-header__search-toggle',function(){
      	event.preventDefault();
    	$('body').addClass("search-drawer-open-header");
      	$('.search-bar input[type="text"]').focus();
  	});
  	$(document).on('click','.search-drawer-open-header .search-bar__close',function(){
      	event.preventDefault();
    	$('body').removeClass("search-drawer-open-header");
  	});
  	$(document).on('click','.search-drawer-open-header .main-content',function(){
      	event.preventDefault();
    	$('body').removeClass("search-drawer-open-header");
  	});
  	
   	/* Left Sidebar menu open js */
  	$(document).on('click', '.js-subnav-toggle' ,function(e){
    	e.preventDefault();
    	var target = this.dataset.target;
    	$('#'+target).slideToggle();
    	$(this).toggleClass('open');
  	});
  	
});


